// @ts-nocheck
import React from 'react';
import * as R from 'ramda';

import { ButtonLink } from '../Button';
import withDrawerActions from '@/containers/Drawer/withDrawerActions';
import { DRAWERS } from '@/constants/drawers';

function DonorDrawerLinkComponent({
  // #ownProps
  children,
  donorId,
  className,

  // #withDrawerActions
  openDrawer,
}) {
  // Handle view customer drawer.
  const handleDonorDrawer = (event) => {
    openDrawer(DRAWERS.DONOR_DETAILS, { donorId });
    event.preventDefault();
  };

  return (
    <ButtonLink className={className} onClick={handleDonorDrawer}>
      {children}
    </ButtonLink>
  );
}

export const DonorDrawerLink = R.compose(withDrawerActions)(
  DonorDrawerLinkComponent,
);
